import { useModal } from "@logora/debate.dialog.modal";
import { FollowButton } from "@logora/parliament.ui.follow_button";
import {
	AddAlert,
	ArrowDropDown,
	CalendarMonthRounded,
} from "@mui/icons-material";
import {
	Box,
	Button,
	Divider,
	ListItemIcon,
	ListItemText,
	Menu,
	MenuItem,
} from "@mui/material";
import { google, ics, outlook } from "calendar-link";
import React, { useState } from "react";
import { MenuItemLink } from "react-admin";
import { AlertModal } from "../alerts/AlertModal";
import { GoogleCalendarIcon } from "./GoogleCalendarIcon";
import { OutlookIcon } from "./OutlookIcon";

function generateCalendarLink(provider, reunion) {
	const event = {
		title: `[${reunion.chambre}] ${reunion.organeReunionRef.libelle}`,
		description: reunion.objet || reunion.compteRenduRef?.quantiemesJournee,
		start: reunion.timestampDebut,
		duration: [1, "hour"],
	};

	switch (provider) {
		case "google":
			return google(event);
		case "outlook":
			return outlook(event);
		default:
			return ics(event);
	}
}

export function FollowReunionButton({ sx, reunion }) {
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<Box sx={sx}>
			<FollowButton onClick={handleClick} />

			<FollowReunionMenu
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				reunion={reunion}
			/>
		</Box>
	);
}

export function FollowReunionMenu({ reunion, open, anchorEl, onClose }) {
	const { showModal } = useModal();

	const closeMenu = () => {
		onClose();
	};

	const openAlertModal = () => {
		closeMenu();
		showModal(<AlertModal />);
	};

	return (
		<Menu
			open={open}
			anchorEl={anchorEl}
			onClose={onClose}
			sx={{ marginTop: 1 }}
		>
			{calendarProviders.map(({ name, label, icon: Icon }) => (
				<MenuItemLink
					key={name}
					to={generateCalendarLink(name, reunion)}
					target="_blank"
					onClick={closeMenu}
				>
					<ListItemIcon>
						<Icon width="24px" height="24px" />
					</ListItemIcon>
					<ListItemText>{label}</ListItemText>
				</MenuItemLink>
			))}

			<Divider />

			<MenuItem onClick={openAlertModal}>
				<ListItemIcon>
					<AddAlert sx={{ width: "28px", height: "28px" }} />
				</ListItemIcon>
				<ListItemText>Créer une alerte compte-rendu disponible</ListItemText>
			</MenuItem>
		</Menu>
	);
}

const calendarProviders = [
	{
		name: "google",
		label: "Exporter dans Google Agenda",
		icon: GoogleCalendarIcon,
	},
	{
		name: "outlook",
		label: "Exporter dans Outlook Calendar",
		icon: OutlookIcon,
	},
	{
		name: "ics",
		label: "Exporter au format ICS",
		icon: CalendarMonthRounded,
	},
];
